<template>
  <div class="form-select-custom" @click="onOpenContent('show')">
    <div class="form-select-custom__value">
      <div class="select-label">{{ label }}</div>
      <div v-if="enableColorInfo" :class="inputModel" class="enable-color-info"></div>
      <div class="select-value">{{ status }}</div>
    </div>
    <form-select-custom-content
      v-if="showContent"
      :input-options="inputOptions"
      :input-model="inputModel"
      :fieldname="fieldname"
      @close="onCloseContent"
      @updateData="updateData"
    />
  </div>
</template>

<script>
import FormSelectCustomContent from "./FormSelectCustomContent.vue";

export default {
  name: "FormSelectCustom",
  components: { FormSelectCustomContent },
  props: {
    inputModel: {
      type: String,
      default: ""
    },
    fieldname: {
      type: String,
      default: ""
    },
    keymonitor: {
      type: Function,
      default: () => {}
    },
    update: {
      type: Function,
      default: () => {}
    },
    label: {
      type: String,
      default: ""
    },
    enableColorInfo: {
      type: Boolean,
      default: false
    },
    inputOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showContent: false
    };
  },
  computed: {
    status: {
      get() {
        const inputOptions = this.inputOptions.find(el => el.value === this.inputModel);
        return inputOptions ? inputOptions.text : "";
      }
    }
  },
  methods: {
    onCloseContent() {
      this.showContent = false;
    },
    updateData(data) {
      this.$emit("update", data);
    },
    onOpenContent(type) {
      if (type) {
        setTimeout(() => {
          this.showContent = true;
        }, 0);
      } else {
        this.showContent = !this.showContent;
      }
    }
  }
};
</script>
